import { render, staticRenderFns } from "./ProductNotification.vue?vue&type=template&id=56becba0&scoped=true"
import script from "./ProductNotification.vue?vue&type=script&lang=js"
export * from "./ProductNotification.vue?vue&type=script&lang=js"
import style0 from "./ProductNotification.vue?vue&type=style&index=0&id=56becba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56becba0",
  null
  
)

export default component.exports